import PageBase from '@common/PageBase';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Organizations/Workspaces/Domain/commands-core';
import Component, { mixins } from 'vue-class-component';

@Component
export default class VuePageCommands extends mixins(PageBase, VueCqrs) {
	invokeAcceptWorkspaceInvitationCommandV1(id: string, recipientEmail: string)
	{
		const cmd = new c.AcceptWorkspaceInvitationCommandV1(id, recipientEmail);
		this.$command(cmd);
	}

	invokeAddUserToWorkspaceCommandV1(id: string, userId: string)
	{
		const cmd = new c.AddUserToWorkspaceCommandV1(id, userId);
		this.$command(cmd);
	}

	invokeCreateWorkspaceCommandV1(id: string, organizationUnitId: number, name: string, description: string, startupUrl: string)
	{
		const cmd = new c.CreateWorkspaceCommandV1(id, organizationUnitId, name, description, startupUrl);
		this.$command(cmd);
	}

	invokeImportToWorkspaceCommandV1(id: string, blobId: string)
	{
		const cmd = new c.ImportToWorkspaceCommandV1(id, blobId);
		this.$command(cmd);
	}

	invokeInviteToWorkspaceCommandV1(id: string, recipientEmail: string)
	{
		const cmd = new c.InviteToWorkspaceCommandV1(id, recipientEmail);
		this.$command(cmd);
	}

	invokeRejectWorkspaceInvitationCommandV1(id: string, recipientEmail: string)
	{
		const cmd = new c.RejectWorkspaceInvitationCommandV1(id, recipientEmail);
		this.$command(cmd);
	}

	invokeRemoveUserFromWorkspaceCommandV1(id: string, userId: string)
	{
		const cmd = new c.RemoveUserFromWorkspaceCommandV1(id, userId);
		this.$command(cmd);
	}

	succeedAnyCommand(status: any) { }
	invalidAnyCommand(status: any) { }
	failedAnyCommand(status: any) { }

	onSetCommandStatus(status: any) {
		status.Success ? 
			this.succeedAnyCommand(status) :
			status.ValidationErrors ?
				this.invalidAnyCommand(status) :
				this.failedAnyCommand(status);

		if (c.AcceptWorkspaceInvitationCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedAcceptWorkspaceInvitationCommandV1(status) :
				status.ValidationErrors ?
					this.invalidAcceptWorkspaceInvitationCommandV1(status) :
					this.failedAcceptWorkspaceInvitationCommandV1(status);
			return;
		}

		if (c.AddUserToWorkspaceCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedAddUserToWorkspaceCommandV1(status) :
				status.ValidationErrors ?
					this.invalidAddUserToWorkspaceCommandV1(status) :
					this.failedAddUserToWorkspaceCommandV1(status);
			return;
		}

		if (c.CreateWorkspaceCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedCreateWorkspaceCommandV1(status) :
				status.ValidationErrors ?
					this.invalidCreateWorkspaceCommandV1(status) :
					this.failedCreateWorkspaceCommandV1(status);
			return;
		}

		if (c.ImportToWorkspaceCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedImportToWorkspaceCommandV1(status) :
				status.ValidationErrors ?
					this.invalidImportToWorkspaceCommandV1(status) :
					this.failedImportToWorkspaceCommandV1(status);
			return;
		}

		if (c.InviteToWorkspaceCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedInviteToWorkspaceCommandV1(status) :
				status.ValidationErrors ?
					this.invalidInviteToWorkspaceCommandV1(status) :
					this.failedInviteToWorkspaceCommandV1(status);
			return;
		}

		if (c.RejectWorkspaceInvitationCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRejectWorkspaceInvitationCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRejectWorkspaceInvitationCommandV1(status) :
					this.failedRejectWorkspaceInvitationCommandV1(status);
			return;
		}

		if (c.RemoveUserFromWorkspaceCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRemoveUserFromWorkspaceCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRemoveUserFromWorkspaceCommandV1(status) :
					this.failedRemoveUserFromWorkspaceCommandV1(status);
			return;
		}

	}

	succeedAcceptWorkspaceInvitationCommandV1(status: any) { }
	invalidAcceptWorkspaceInvitationCommandV1(status: any) { }
	failedAcceptWorkspaceInvitationCommandV1(status: any) { }

	succeedAddUserToWorkspaceCommandV1(status: any) { }
	invalidAddUserToWorkspaceCommandV1(status: any) { }
	failedAddUserToWorkspaceCommandV1(status: any) { }

	succeedCreateWorkspaceCommandV1(status: any) { }
	invalidCreateWorkspaceCommandV1(status: any) { }
	failedCreateWorkspaceCommandV1(status: any) { }

	succeedImportToWorkspaceCommandV1(status: any) { }
	invalidImportToWorkspaceCommandV1(status: any) { }
	failedImportToWorkspaceCommandV1(status: any) { }

	succeedInviteToWorkspaceCommandV1(status: any) { }
	invalidInviteToWorkspaceCommandV1(status: any) { }
	failedInviteToWorkspaceCommandV1(status: any) { }

	succeedRejectWorkspaceInvitationCommandV1(status: any) { }
	invalidRejectWorkspaceInvitationCommandV1(status: any) { }
	failedRejectWorkspaceInvitationCommandV1(status: any) { }

	succeedRemoveUserFromWorkspaceCommandV1(status: any) { }
	invalidRemoveUserFromWorkspaceCommandV1(status: any) { }
	failedRemoveUserFromWorkspaceCommandV1(status: any) { }

}
